import BreadCrumbs from 'components/breadcrumbs'
import { Card, CardBody } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useFetchAttendanceSummaryQuery } from 'features/private-views/attendance-summary/attendanceSummaryApiSlice'
import TableSummary from 'features/private-views/attendance-summary/TableSummary'
import { useEffect } from 'react'
import { setFetchOption } from '../../attendance-summary/attendanceSummarySlice'

const AttendanceIndividualManagement = () => {
  const { tag } = useSelector((s) => s.attendanceSummary)
  const dispatch = useDispatch()

  const res = useFetchAttendanceSummaryQuery(
    {
      ...tag,
    },
    { skip: !tag?.memberUserId || !tag },
  )

  useEffect(() => {
    dispatch(
      setFetchOption({
        s: undefined,
      }),
    )
  }, [])

  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Laporan Absensi Anggota'} />
      </div>
      <div className="d-flex flex-column gap-2 mb-2">
        <Card className="border-0 shadow-sm">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Laporan Absensi Anggota</h5>
            </div>

            <TableSummary res={res} selectMember />
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default AttendanceIndividualManagement
